import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay,debounceTime } from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
//import  dataurl from '../../assets/config.json';
export interface Dropobj {

  label;
  value;


  }

  declare function Getapiurl():any;

@Injectable()
export class MychampService {

    callurl: string = '';
    pdfurl:string='';
  
clcd:string;
aycd:string;
usid:string;
insid:string;
clid:string;
scid:string;
crid:string;

    constructor(private http: HttpClient,private _global: AppGlobals) {

       this.clcd=localStorage.getItem('clcd');
       this.aycd=localStorage.getItem('aycd');
       this.usid=localStorage.getItem('usid');
       this.insid=localStorage.getItem('insid');
       this.clid=localStorage.getItem('clid');
       this.scid=localStorage.getItem('scid');
       this.crid=localStorage.getItem('crid');
     
       this.callurl=_global.baseAPIUrl;
       this.pdfurl=_global.pdfurl;
     }

     getipurl(): any {
      debugger
     //let clcd=localStorage.getItem('clcd');
     const headers = new HttpHeaders();
     headers.append('Content-Type', 'application/json')
         
         headers .append('Access-Control-Allow-Methods', 'GET')
         headers.append('Access-Control-Allow-Origin', '*'); 
         headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
     return this.http.get('http://mycampuz.co.in/ipwithport.php',{responseType:'text', headers:headers})
     .pipe(map((data: any) => {
             console.log('retres',JSON.stringify(data));
             this.callurl= data+'/mycampz/v3/';
         }));
   }

   getdatetoday()
   {
    let d: Date = new Date();
    var mnth;
    var day='';
    //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
    if(d.getMonth()>=10)
    {
      mnth=d.getMonth()+1;
    }
    else{
     // mnth='0'+d.getMonth()+1;
     mnth=d.getMonth()+1;
     mnth='0'+mnth;
    }
 
    if(d.getDate()>=10)
    {
      day=d.getDate().toString();
    }
    else{
      day='0'+d.getDate();
    }
    let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
      
 return todayDate;
 
   }

   getsysdatetoday()
   {
    return this.http.get(this.callurl + 'getsysdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

   getmontfirstdate()
   {
    return this.http.get(this.callurl + 'getfirstdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }

   getmontlastdate()
   {
    return this.http.get(this.callurl + 'getlastdate')
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
 
   }
    Getdashboarddata(oprtype): Observable<any> {
        //let clcd=localStorage.getItem('clcd');
        
        let postdat={clcd:this.clcd,aycd:this.aycd}
        //console.log('url',this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/'+oprtype);
        return this.http.get(this.callurl + 'libdashboard/'+this.clcd+'/'+this.aycd+'/'+oprtype)
        .pipe(map((data: any) => {
                console.log('retres', data);
                return data.dashboard;
            }));
    }


    getBooks() {
        return this.http.get<any>('assets/books.json')
          .toPromise()
          .then(res => res.data)
          .then(data => { return data; });
        }

        getjobposts(): Observable<any> {
          debugger
          // let clcd=localStorage.getItem('clcd');
          // let aycd=localStorage.getItem('aycd');
          let postdat={clcd:this.clcd,aycd:this.aycd}
          return this.http.get(this.callurl + 'getjobposts/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.insid)
          .pipe(map((data: any) => {
                  console.log('bookdetails', data);
                  return data.joblist;
                  
              }));
      }

      saveprofileinfo(objprof): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');
       objprof.clcd=this.clcd;
       objprof.aycd=this.aycd;
       objprof.stuid=this.usid;
console.log('objprof',objprof);
        return this.http.post(this.callurl + 'Save_profiledetails', objprof)
        .pipe(map((data: any) => {
                console.log('profsavedetails', data);
                return data;
                
            }));
    }


    uploadmemberphoto(data: File,objprof): Observable<any> {
      /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
    debugger
      const formData: FormData = new FormData();
     // console.log("stuid",bkid)
      formData.append('Image', data, data.name);
        
        
        formData.append('clcd', this.clcd);
        formData.append('aycd', this.aycd);
        formData.append('stuid', this.usid);
        formData.append('stunm', objprof.stunm);
        console.log("formData",formData);
       return this.http.post(this._global.baseAPIUrl + 'uploadstudentprofile', formData)
       .pipe(map((data: any) => {
           console.log('retres', data);
           return data
       }));
    }


    applycanceljob(objprof): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');
     objprof.clcd=this.clcd;
     objprof.aycd=this.aycd;
     objprof.stuid=this.usid;
     objprof.insid=this.insid;
console.log('objprof',objprof);
      return this.http.post(this.callurl + 'applycanceljob', objprof)
      .pipe(map((data: any) => {
              console.log('applycanceljob', data);
              return data;
              
          }));
  }

  notifications(oprtype): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');
    var objprof:any={};
   objprof.clcd=this.clcd;
   objprof.aycd=this.aycd;
   objprof.stuid=this.usid;
   objprof.clid=this.clid;
   objprof.scid=this.scid;
   objprof.crid=this.crid;
   objprof.oprtype=oprtype;
console.log('objprof',objprof);
    return this.http.post(this.callurl + 'notification', objprof)
    .pipe(map((data: any) => {
            console.log('notification', data);
            return data;
            
        }));
}

assignments(oprtype): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};
 objprof.clcd=this.clcd;
 objprof.aycd=this.aycd;
 objprof.stuid=this.usid;
 objprof.clid=this.clid;
 objprof.scid=this.scid;
 objprof.crid=this.crid;
 objprof.oprtype=oprtype;
console.log('objprof',objprof);
  return this.http.post(this.callurl + 'assignments', objprof)
  .pipe(map((data: any) => {
          console.log('assignments', data);
          return data;
          
      }));
}


todoevents(oprtype): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};
 objprof.clcd=this.clcd;
 objprof.aycd=this.aycd;

 objprof.oprtype=oprtype;
console.log('objprof',objprof);
  return this.http.get(this.callurl + 'eventlist/'+this.clcd+'/'+this.aycd+'/'+oprtype)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}

getfees(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'StuFeestruct1/'+this.clcd+'/'+this.aycd+'/'+this.usid)
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}


getreporthead(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'StuReport/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.clid+'/'+this.scid+'/'+this.crid+'/0/head')
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}

getreportdet(asid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'StuReportD/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+this.clid+'/'+this.scid+'/'+this.crid+'/'+asid+'/det')
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}


feerech(oprtype,vhno) {
  debugger
  var postdata={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,vhno:vhno};
     return this.http.post(this.callurl + 'getpartpayments1',postdata)
         .pipe(map((data: any) => {
console.log('data',data);
             // console.log=('log',data.classdata)
             return data.paylst;
         }))
 }

  updateplacement(oprtype): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');
    let postdat={clcd:this.clcd,aycd:this.aycd}
    return this.http.get(this.callurl + 'updateplacement/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+oprtype+'/'+this.insid)
    .pipe(map((data: any) => {
            console.log('bookdetails', data);
            return data
            
        }));
}

      boooksborowed(oprtype: any,memid:any): Observable<any> {
        debugger
        // let clcd=localStorage.getItem('clcd');
        // let aycd=localStorage.getItem('aycd');
        let postdat={clcd:119,aycd:2,oprtype:oprtype,memid:memid}
        return this.http.post(this.callurl+ 'libborrowed', postdat)
            .pipe(map((data: any) => {
                console.log('retres', data);
                return data;
            }),delay(2000));
    }

    libopac_elink_quest(oprtype: any,memid:any,sertxt:any): Observable<any> {
      debugger
      // let clcd=localStorage.getItem('clcd');
      // let aycd=localStorage.getItem('aycd');
      let postdat={clcd:119,aycd:2,oprtype:oprtype,memid:memid,sertxt:sertxt};
      return this.http.post(this.callurl+ 'libopac_elink_quest', postdat)
      .pipe(debounceTime(2000),map((data: any) => {
        console.log('retres', data);
        return data.arrresult;
    }));

          // .pipe(map((data: any) => {
          //     console.log('retres', data);
          //     return data.arrresult;
          // }),delay(2000));
  }

  getstudentprofile(): Observable<any> {
    //let clcd=localStorage.getItem('clcd');
    
    
    return this.http.get(this.callurl + 'studentprofile/'+this.clcd+'/'+this.aycd+'/'+this.usid)
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data.studentprofile;
        }));
}


payapi(jsonstafupddtls: any): Observable<any> {
        
 // this.callurl='http://49.205.199.224:8082/mychamp/api/v3/ccavencrypt.php';
  // this.callurl=this.baseUrl+'Payenqrequest'
   return this.http.post( this.callurl+"ccavencrypt.php", jsonstafupddtls )
       .pipe(map((data: any) => 
       {
           console.log('retres',data);
           return  data ; 
       }));
}  

paymentrequestdata(obj) {
  debugger
  var postdata={jsonpayrequest:{clcd:this.clcd,aycd:this.aycd,stuid:obj.stuid,insid:obj.Insid,deptid:obj.depid}};
  console.log('post',postdata);
     return this.http.post(this.callurl + 'paymentrequestdata',postdata)
         .pipe(map((data: any) => {
console.log('data',data);
             // console.log=('log',data.classdata)
             return data.paymentrequestdataResult;
         }))
 }


 getresults(clid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  var objprof:any={};

  return this.http.get(this.callurl + 'results/'+this.clcd+'/'+this.aycd+'/'+this.usid+'/'+clid+'/'+this.scid+'/0/0')
  .pipe(map((data: any) => {
          console.log('notification', data);
          return data;
          
      }));
}

}